export const calendarTranslations = {
  'calendar.selectDate': {
    en: 'Select date',
    fi: 'Valitse päivä'
  },
  'calendar.use': {
    en: 'Use',
    fi: 'Käytä'
  },
  'calendar.day': {
    en: 'Day',
    fi: 'Päivä'
  },
  'calendar.week': {
    en: 'Week',
    fi: 'Viikko'
  },
  'calendar.month': {
    en: 'Month',
    fi: 'Kuukausi'
  },
  'calendar.range': {
    en: 'Range',
    fi: 'Aikaväli'
  },
  'calendar.mon': {
    en: 'Mon',
    fi: 'Ma'
  },
  'calendar.tue': {
    en: 'Tue',
    fi: 'Ti'
  },
  'calendar.wed': {
    en: 'Wed',
    fi: 'Ke'
  },
  'calendar.thu': {
    en: 'Thu',
    fi: 'To'
  },
  'calendar.fri': {
    en: 'Fri',
    fi: 'Pe'
  },
  'calendar.sat': {
    en: 'Sat',
    fi: 'La'
  },
  'calendar.sun': {
    en: 'Sun',
    fi: 'Su'
  }
};
